<template>
  <div id="tool-block">
    <div class="tools-btn-block">
      <div :class="feature.id == featureData.featureId ? 'active' : ''" v-for="feature in features" :key="feature.id">
        <a href="#" @click="changeFeature(feature.id)">
          <img :src="feature.src" alt="">
          <span>{{ feature.name }}</span>
        </a>
      </div>
    </div>
    <Transition name="toolPanel">
      <div class="tool-panel" :class="[toolPanelClass, toolPanelSpecialClass]">
        <div v-show="featureData.featureId && featureData.showInPanel" class="title-block">
          <img v-show="isSubTitle" src="../../images/tools/back_icon.svg" alt="" width="15" @click="handleBackClick" style="cursor: pointer; position: absolute; left: 10px; top: 10px;">
          <img v-if="featureData.moduleChildPanel" src="../../images/tools/back_icon.svg" alt="" width="15" @click="setFeatureData('moduleChildPanel', false)" style="cursor: pointer; position: absolute; left: 10px; top: 10px; z-index: 2;">
          <span class="panel-title">{{ featureData.panelTitle }}</span>
          <a style="position: absolute; right: 10px; top: 10px; cursor: pointer;" @click="setFeatureData('featureId', NaN)">&#10006;</a>
        </div>

        <div class="panel-content" ref="panelComponent">
          <slot name="featurePanel">
            <div class="welcome">
              <span class="title">開始您的產品設計</span>
              <div class="tool-menu">
                <div class="detail" v-for="feature in features" :key="feature.name">
                  <a v-show="feature.main" @click="changeFeature(feature.id)">
                    <img :src="feature.src" alt="">
                    <span>{{ feature.name }}</span>
                  </a>
                </div>
              </div>
              <div class="mt-3 d-flex">
                <span>或</span>&emsp;<a href="#" style="text-decoration: none;" @click="canvasClear()">重新開始</a>
              </div>
            </div>
          </slot>
        </div>
      </div>
    </Transition>
    <input v-if="isMobile && featureData.uploadFiles.length == 0" id="file-input-without-panel" type="file" style="display: none;" @change="handleFileChange" />
  </div>
</template>

<script setup>
  import { ref, defineProps, onMounted, computed, defineEmits, watch } from 'vue'
  import { featureData, isMobile, setFeatureData, handleUpload, setScollTop } from "~/vues/utils/feature.js"

  const props = defineProps({
    features: {
      type: Array,
      required: true
    },
    cancelActiveObj: {
      type: Function,
      required: true
    },
    isLoadingImage: {
      type: Boolean,
      required: true,
    }
  }) 

  const { features } = props
  const emit = defineEmits(['clearCanvas'])

  // const isMobile = ref(false);
  const isSubTitle = computed(() => {
    return !features.map(x => x.name).includes(featureData.panelTitle)
  })
  const currentMainTitle = computed(() => {
    return featureData.featureId ? features.find(x => x.id == featureData.featureId)?.name : ''
  })
  const toolPanelClass = computed(() => {
    var UploadImageComponent = features.find(x => x.id == featureData.featureId)?.component
    return !featureData.showInPanel || !featureData.featureId || (UploadImageComponent == 'UploadImage' && featureData.uploadFiles.length == 0 && !featureData.activeObj.id) ? 'mobile-hide' : ''
  })
  const toolPanelSpecialClass = computed(() => {
    var AddModuleComponent = features.find(x => x.id == featureData.featureId)?.component
    return (AddModuleComponent == 'AddModule' && !featureData.activeObj.id) ||
      (featureData.panelTitle == '修改字型') 
      ? 'tool-panel-mobile-modal' : ''
  })

  const panelComponent = ref(null);
  
  watch(() => featureData.activeObj, () => {
    if(featureData.featureId) setScollTop(panelComponent.value.children[0])
  }, {deep: true})

  const handleBackClick = () => {
    setFeatureData('panelTitle', currentMainTitle.value)
    setScollTop(panelComponent.value.children[0])
  }

  const changeFeature = (featureId) => {
    if(props.isLoadingImage) return;
    var UploadImageComponent = features.find(x => x.id == featureId)?.component
    if (isMobile.value && UploadImageComponent == 'UploadImage' && featureData.uploadFiles.length == 0) {
      const fileInput = document.getElementById('file-input-without-panel');
      if (fileInput) {
        fileInput.click();
        props.cancelActiveObj()
        setFeatureData('featureId', featureId)
      }
    } else {
      props.cancelActiveObj()
      setFeatureData('featureId', featureId)
    }
  }

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    // 處理上傳檔案的邏輯
    handleUpload(file);

    event.target.value = '';
  };

  const canvasClear = () => {
    emit('clearCanvas')
  }
</script>